import React, { CSSProperties, FC } from 'react';
import { FaSpinner } from 'react-icons/fa';
import styled, { keyframes } from 'styled-components';

export interface IProps {
  size?: number;
  color?: string;
  style?: CSSProperties;
}

const Spinner: FC<IProps> = ({ size = 14, color, style }: IProps) => {
  return (
    <AnimatedIcon
      size={size}
      color={color}
      style={style}
    />
  );
};

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const AnimatedIcon = styled(FaSpinner)`
  animation: ${rotate} 2s infinite linear;
`;

export default Spinner;
